/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const SaveBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M5 18a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8.243a1 1 0 0 0-.293-.707l-2.242-2.243A1 1 0 0 0 16 5.03V8.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V5a1 1 0 0 0-1 1v12Zm9-11V5H8v2h6ZM6.5 3h9.257a3 3 0 0 1 2.122.879L20.12 6.12A3 3 0 0 1 21 8.243V18a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h.5ZM10 14a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z" /></svg>);
const Save = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={SaveBase} {...rest} ref={ref} />);
export default Save;